export default "__VITE_ASSET__D4P2AYGx__"